<template>
  <div>
    <transition name="el-zoom-in-top" mode="out-in">
      <div class="lang-tips-wrap" v-show="isShow">
        <div class="lang-tips-icon">!</div>

        <div class="lang-tips-text">
          <p>
            This content does not have an English version, but a Chinese
            version, as shown below.
          </p>

          <div class="lang-tips-check-box" @click="check">
            <span
              class="lang-tips-check"
              :class="[isChecked ? 'is-checked' : '']"
            ></span>

            Do not show this message again.
          </div>
        </div>

        <a href="javascript:;" class="lang-tips-close" @click="close"
          >&times;</a
        >
      </div>
    </transition>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  name: 'sk-nonsupport-i18n',
  data() {
    return {
      isShow: false,
      isChecked: false,
      pin: Cookie.get('pin'),
    }
  },
  created() {
    let isEn = Cookie.get('jdcloud_sitelang') === 'en' ? true : false
    let isHidden = Cookie.get(this.pin + '-hide-noEnLang-tip')
    if (isEn && !isHidden) {
      this.isShow = true
    }
  },
  methods: {
    close() {
      this.isShow = false
      if (this.isChecked) {
        Cookie.set(this.pin + '-hide-noEnLang-tip', true)
      }
    },
    check() {
      this.isChecked = !this.isChecked
    },
  },
}
</script>

<style scoped="true">
.lang-tips-wrap {
  position: relative;
  padding: 10px;
  background: #fffdf0;
  border: 1px solid #fab418;
  color: #fff;
  font-size: 12px;
}
.lang-tips-wrap .lang-tips-icon {
  float: left;
  width: 17px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  margin-right: 10px;
  color: #fff;
  font-size: 14px;
  background-color: #fab418;
  -ms-border-radius: 17px;
  border-radius: 17px;
}
.lang-tips-wrap .lang-tips-text {
  overflow: hidden;
  line-height: 18px;
  padding-right: 40px;
}
.lang-tips-wrap .lang-tips-text p {
  font-size: 14px;
  color: #666;
}
.lang-tips-check-box {
  margin-top: 5px;
  color: #999;
  display: inline-block;
  cursor: pointer;
}
.lang-tips-close {
  position: absolute;
  top: 0;
  right: 5px;
  color: #979797;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 24px;
}
.lang-tips-close:hover {
  color: #bbb;
}
.lang-tips-check {
  display: inline-block;
  position: relative;
  width: 16px;
  margin-right: 10px;
  height: 16px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #d9e1e9;
  vertical-align: -4px;
}
.lang-tips-check.is-checked {
  background: #2aafff;
  border-color: #2aafff;
}
.lang-tips-check.is-checked:after {
  transform: rotate(45deg) scaleY(1);
}
.lang-tips-check:after {
  box-sizing: content-box;
  content: '';
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 8px;
  left: 5px;
  position: absolute;
  top: 2px;
  transform: rotate(45deg) scaleY(0);
  width: 4px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}

.pointer {
  cursor: pointer;
}
</style>
